import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ai{align-items:flex-start;}.ssr-plugin'
import '.c{gap:1.5rem;}.ssr-plugin'
import '.e9{background:var(--palette-white);}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.fz{justify-content:flex-start;}.ssr-plugin'
import '.gg{gap:2.5rem;}.ssr-plugin'
import '.aj{flex-wrap:wrap;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.k9{font-size:4rem;}.ssr-plugin'
import '.cj{font-weight:700;}.ssr-plugin'
import '.ka{line-height:100%;}.ssr-plugin'
import '.hg{margin:0px;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.a6{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'

export interface NutshellItem {
  total: string | number
  subtitle: string
}

export interface NutshellProps {
  heading: string
  items: NutshellItem[]
  style?: Style
}

export const Nutshell = ({ heading, items, style }: NutshellProps) => {
  return (
    <styled.div className="d e ai c e9"
      data-testid="nutshell"
      style={{
        ...style,
      }}
    >
      {/* Heading */}
      <Title.H4
        style={{
          color: 'var(--brand-secondary)',
          textAlign: 'center',
          margin: 0,
        }}
      >
        {heading}
      </Title.H4>

      {/* Data Points Container */}
      <div className="d s fz ai gg aj"
      >
        {items.map((item, index) => (
          <div className="d e t u"
            key={index}
          >
            <div className="k9 cj ka hg a5 a6"
            >
              {item.total}
            </div>

            {/* Subtitle */}
            <Text.Medium
              style={{
                color: 'var(--brand-secondary)',
                opacity: 0.6,
                margin: 0,
                textAlign: 'center',
              }}
            >
              {item.subtitle}
            </Text.Medium>
          </div>
        ))}
      </div>
    </styled.div>
  )
}
